import { createTheme } from "@mantine/core";

export function getLinearGradient(type: string) {
  switch (type) {
    case "primary":
      return `linear-gradient(45deg, ${getBrandColor(
        "primary"
      )}, ${getBrandColor("secondary")})`;
    case "gray":
      return "linear-gradient(145deg, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0) 100%)";
    default:
      return undefined;
  }
}

export const getBrandColor = (color: string) => {
  switch (color) {
    case "primary":
      return mantineTheme.colors!.primary![6];
    case "secondary":
      return mantineTheme.colors!.secondary![6];
    case "tertiary":
      return mantineTheme.colors!.tertiary![6];
    default:
      return undefined;
  }
};

export const mantineTheme = createTheme({
  colors: {
    // Primary color - Collabish Purple
    primary: [
      "#F0E5FF", // Lightest shade
      "#DECBFF",
      "#C9ADFF",
      "#B38FFF",
      "#9C71FF",
      "#8452FF",
      "#6A00DB", // Your brand purple from the SVG
      "#5900B9",
      "#480097",
      "#370075", // Darkest shade
    ],
    // Secondary color - Teal (complementary to purple)
    secondary: [
      "#E0F7F6",
      "#C2EEEC",
      "#A3E5E2",
      "#85DCD8",
      "#66D3CE",
      "#48CAC4",
      "#29C1BA", // Base secondary color
      "#23A59F",
      "#1D8984",
      "#176D69",
    ],
    // Tertiary color - Coral (creates a nice triad with purple and teal)
    tertiary: [
      "#FFEDE8",
      "#FFDBD1",
      "#FFC9BA",
      "#FFB7A3",
      "#FFA58C",
      "#FF9375",
      "#FF815E", // Base tertiary color
      "#E56E50",
      "#CC5B42",
      "#B24834",
    ],
  },
  primaryColor: "primary",
  components: {
    List: {
      styles: {
        itemWrapper: {
          width: "100%",
        },
        itemLabel: {
          width: "100%",
        },
      },
    },
  },
  // You can add other theme overrides here
  // fontFamily: 'Inter, sans-serif',
  // defaultRadius: 'md',
});
